module.exports = {
    welcome: "Welcome ru",
    menu: "menu",
    home: "home",
    dashboard: "Dashboard",
    Posts: "Posts",
    Create: "Create",
    post: "post",
    view: "View",
    login: "Вход",
    language: "language",
    edit: "Редактировать",
    delete: "delete",
    action: "action",
    prefix: "prefix",
    save: "Сохранить",
    categories: "categories",
    seo: "Seo",
    title: "title",
    select: "Выбрать",
    slug: "slug",
    short: "short",
    content: "content",
    table: "table",
    tables: "tables",
    quantity: "quantity",
    photo: "photo",
    choose: "choose",
    file: "file",
    update: "Обновлено",
    result: "Rresult",
    schema: "schema",
    database: "database",
    settings: "settings",
    controll: "controll",
    tariff: "tariff",
    add: "add",
    advices: "advices",
    advice: "advice",
    feedbacks: "feedbacks",
    active: "Active",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    /* nerqev */
    contact: "Контакт",
    contacts: "Контакты",
    blog: "Блог",
    about_as: "О нас",
    Just_3_simple_steps: "Всего 3 простых шага",
    download: "Скачать",
    Create_your_resume_right_now: "Создать резюме онлайн за 5 минут",
    cv_editor_message: "Для того чтобы создать онлайн резюме рекомендуем воспользоваться нашим сервисом. Это простой и быстрый шанс «нарисовать» резюме, на которое в обязательном порядке обратят внимание ваши будущие директора. Очень удобный и простой интерфейс позволит создать резюме даже самому неопытному пользователю компьютера.  На интуитивном уровне Вы сможете оформить классное, яркое и запоминающееся резюме, которое понравится вам и вашему работодателю. После того, как мы поможем Вам создать резюме вы с легкостью сможете разместить его в любом месте. Желаем приятное создание резюме. ",
    Create_your_resume_large_text:
        "Для Вашей «Кариерной карточки» CVWEB предлагает идеальные и креативные формы, которые позволят правильно организовать ваш опыт и цель резюме, ведь от этого зависит ваша будущая работа. Профессиональные HR-специалисты советуют наш сайт, как один из самых лучших, где каждый соискатель может найти собственный образец для работы. От Вас требуется оформить яркие и творческие резюме последуя нашим советам.",
    resume: "Резюме",
    created: "Создано",
    CV_in: "Резюме за",
    minutes: "минут",
    Popular_posts: "Популярные посты",
    Our_advice: "Наши советы",
    bestsellers: "Бестселлеры",
    our_feedback: "Наши отзывы",
    Your_feedbacks: "Ваши отзывы",
    Read_more: "Прочитайте больше",
    write_us: "Напиши нам",
    create_resume: "Создать резюме",
    send: "Отправить",
    email_error: "неверно указана почта",
    email: "Эл. адрес",
    find_your_account: "Восстановить профиль ",
    password: "Пароль",
    password_confirmation: "Подтверждение пароля",
    new_password: "Новый пароль",
    registration: "Регистрация",
    sign_in: "Войти",
    remamber_me: "Запомни меня",
    forgot_password: "Забыли пароль?",
    name: "Имя",
    surname: "Фамилия",
    logout: "Выйти",
    change_password: "Изменить пароль",
    old_password: "Старый пароль",
    basic_info: "Личные данные",
    job_stack: 'График работы',
    profession: "Профессии",
    skills: "Навыки",
    languages: "Языки",
    hobby: "Хобби",
    education: "Образование",
    work_experience: "Опыт работы",
    social: 'Соц. сети',
    citizen: "Гражданин",
    cv_contact: "Контакт",
    career_objective: "Карьерная цель",
    year: 'Год',
    phone: "Телефон",
    birthday: "День рождения",
    address: "Адрес",
    start: "Начало",
    end: "Окончание",
    company: "Компания",
    specialization: "Специализация",
    degree: "Степень",
    university: "Университет",
    faculty: "Факультет",
    location: "Местоположение",
    description: "Описание",
    from: "От",
    full_stack: "Полный",
    contractual: "Договорный",
    our_advices: "Наши советы",
    category: "Категория",
    we_in_social: "Мы в соцсетях",
    crweb_address: "Тпагричнер 4 <br><br> Ереван, Армения 0010",
    vacancy: "Работа",
    present: "Настоящее время",
    monthly: "Ежемесячно",
    select_empty: "Список пуст",
    achievement: "Достижение",
    facebook_foot_link: "https://www.facebook.com/CVwebRussian",
    instagram_foot_link: "https://www.instagram.com/cvweb.ru",
    conditions: "Условия",
    no_elements: "Элементы не найдены.",
    new_user_created: "Новый пользователь создан",
    you_accounts_has_merged: "Your accounts has merged",
    CV_language: 'Язык',
    course:'₽',
    //errors
    invalid_email: 'Неверная электронная почта',
    invalid_password: 'Пароль невалидный',
    invalid_password_confirmation: 'Пароль не совпадает',
    policy: 'Политикой конфиденциальности',
    policy_title: 'ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ <br> ДАННЫХ ООО «КРЕАТИВ ВЕБ»',
    Last_edited : 'Ваши резюме',
    Zoom : 'Увеличивать',
    Rotation : 'Прокрутить ',
    teoken_sended : 'Ссылка восстановление пароля отправлен на почту.',
    please_verify : 'Пожалуйста, подтвердите',
    'The photo must be a file of type: jpeg, jpg, png.': 'Фотография должна быть в формате jpg, jpeg, png.',
    'The photo may not be greater than 10240 kilobytes.': 'Фотография не может быть больше 10 мегабайт.',
    specialist_consultant:'Специалист-консультант',
    message_title:'Ведите ваше сообщение',
    themes: "Темы",
    backtohomepage: 'Գլխավոր էջ',
    sorry_404: 'Տվյալ էջը գոյություն չունի:',
    thanks_d: 'Спасибо <br> что выбрали нас',
    payment_error: 'Оплата не была произведена, проверьте данные своей карты и попробуйте снова.',
    payment_message: 'Платежное сообщение',
    authentication_fails: 'Неправильные данные',
    day: 'д.',
    hour: 'ч.',
    transfer: 'Перевести',
    old_password_invalid: "Старый пароль не верный",
    attention: "Внимание!",
    changed: "Пароль изменен",
    recover: "Восстанавливать",
    error: "Неудачный",
    success: "Успешно!",
    FAQ: "ЧАВО",
    shear_text: "Или скажите о нас друзьям и бесплатно получите тариф",
    registration_success: "Вы успешно зарегистрировались",
    server_error: "Попробуйте снова, что то пошёл не так",
    save_resume: "Всё отлично, резюме сохранился",
    cv_delete: "Резюме удален",
    image_change: "Картинка сохранена",
    sent_message: "Письмо отправлено",
    input_promo_code: "Вводить промокод",
    promo_code: "Промокод",
    new__cv: "Создать новый",
    go__cvs: "Созданные резюме",
    there__are__cv: "У вас уже есть такой тип резюме: <br/> Вы хотите создать новый?"
};



// WEBPACK FOOTER //
// ./resources/js/lang/ru.js